export const LOGIN_TOKEN_KEY = 'wavesworn.token';

/** The 64-hex login token in a `#token=...` URL hash, or null. */
export function tokenFromHash(hash: string): string | null {
  return /^#token=([0-9a-f]{64})$/.exec(hash)?.[1] ?? null;
}

/** Stores a token handed back by the auth redirect, clears the hash, and returns the stored token. */
export function takeLoginToken(): string | null {
  try {
    const t = tokenFromHash(location.hash);
    if (t) {
      localStorage.setItem(LOGIN_TOKEN_KEY, t);
      history.replaceState(null, '', location.pathname + location.search);
    }
    return localStorage.getItem(LOGIN_TOKEN_KEY);
  } catch { return null; } // private mode: login cannot persist
}

export function showLogin(): void {
  const el = document.createElement('div');
  el.id = 'login';
  el.innerHTML = '<h1>Wavesworn</h1><p>Sail, trade, and build your captain in a shared world.</p><a class="btn" href="/auth/discord">Login with Discord</a><p>Your progress is saved to your account.</p>'
    + (import.meta.env.DEV ? '<form action="/auth/dev"><input name="name" value="dev" aria-label="Dev name" /><button>Dev login</button></form>' : '');
  document.body.append(el);
}

/** Blocking overlay after the server turned this tab's protocol away; only a reload loads the new client. */
export function showOutdated(): void {
  if (document.getElementById('outdated')) return;
  const el = document.createElement('div');
  el.id = 'outdated';
  el.setAttribute('role', 'alertdialog');
  el.setAttribute('aria-modal', 'true');
  el.setAttribute('aria-labelledby', 'outdated-msg');
  el.innerHTML = '<p id="outdated-msg">A new version of Wavesworn is out.</p><button type="button">Reload</button>';
  const b = el.querySelector('button')!;
  b.onclick = () => location.reload();
  document.body.append(el);
  b.focus();
}

/** Clear this browser's game credentials; navigating closes its active socket. */
export function signOut(): void {
  localStorage.removeItem(LOGIN_TOKEN_KEY);
  localStorage.removeItem('wavesworn.resume');
  location.assign(location.pathname);
}
